<template>
    <div class="mt-5">
        <div class="grid grid-cols-7 gap-1.5">
            <div>
                <navigation
                    :navigation="[
                        {
                            name: 'Usuários',
                            route: { name: 'finnancial.chargebacks.users' },
                            icon: UsersIcon,
                        },
                        {
                            name: 'Disputas',
                            route: { name: 'finnancial.chargebacks.disputes' },
                            icon: CubeIcon,
                        },
                        {
                            name: 'Pre Chargebacks',
                            route: {
                                name: 'finnancial.chargebacks.pre-chargebacks',
                            },
                            icon: BellIcon,
                        },
                        {
                            name: 'Importar Transações',
                            route: {
                                name: 'finnancial.chargebacks.transaction-import',
                            },
                            icon: DocumentArrowUpIcon,
                        },
                    ]"
                />
            </div>
            <div class="col-span-6">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import Navigation from "../../../components/layouts/navigation/vertical/Navigation.vue";
import { UsersIcon, CubeIcon, BellIcon, DocumentArrowUpIcon } from "@heroicons/vue/24/outline";

export default {
    components: { Navigation },
    methods: { UsersIcon, CubeIcon, BellIcon, DocumentArrowUpIcon },
};
</script>
